import React from 'react'
import { SelectDropdown, Wrapper } from 'SRC/ui/FormElementsNew'

import config from 'SRC/config/config.yaml'
import { useFormikContext } from 'formik'

const { adPriceTypes } = config.adForm

const data = [
  {
    id: `${adPriceTypes.fixed.id}`,
    label: adPriceTypes.fixed.title,
    value: `${adPriceTypes.fixed.id}`
  },
  {
    id: `${adPriceTypes.negotiated.id}`,
    label: adPriceTypes.negotiated.title,
    value: `${adPriceTypes.negotiated.id}`
  },
  {
    id: `${adPriceTypes.urgent.id}`,
    label: adPriceTypes.urgent.title,
    value: `${adPriceTypes.urgent.id}`
  }
]

export const PriceType = () => {
	const formik = useFormikContext()

	return (
		<Wrapper>
			<SelectDropdown
				id='priceType'
				title='Tip cijene'
				isRequired
				isSearchable={false}
				isOptional={false}
				value={formik.values.priceType}
				options={data}
				onChange={priceType => {
					console.log('priceType selected', priceType)

					formik.setFieldValue('priceType',priceType)
				}}
			/>
		</Wrapper>
	)
}